import { z } from 'zod'

export const batchAssignSplitCategorySchema = z.object({
  expenseIds: z.array(z.string().guid()).min(1).max(500),
  categoryId: z.string().guid(),
})

export type BatchAssignSplitCategoryDto = z.infer<typeof batchAssignSplitCategorySchema>
